// extracted by mini-css-extract-plugin
export default {"wrapper":"eU-z","availablePromoMessagesLabel":"fU-z","promoMessageList":"gU-z","promoMessage":"hU-z","appliedPromoMessage":"iU-z","promoMessageAmount":"jU-z"};